import { esPlanVigente, obtenerPrimero, parsearJsonSeguro } from './configuracionInicial.constants';
import { obtenerPreguntasPendientes } from './navegacionConfiguracionInicial';

export const bloqueosDelPlan = (plan) => {
  const contenido = parsearJsonSeguro(obtenerPrimero(plan, ['ContenidoPlanJson', 'contenidoPlanJson'], null));
  const validaciones = obtenerPrimero(contenido, ['Validaciones', 'validaciones'], []);
  const bloqueos = (Array.isArray(validaciones) ? validaciones : []).filter(item =>
    ['BLOQUEANTE', 'BLOQUEADA', 'ERROR'].includes(String(obtenerPrimero(item, ['Estado', 'estado'], '')).toUpperCase()));
  const especificos = bloqueos.filter(item => obtenerPrimero(item, ['Codigo', 'codigo'], '') !== 'APLICACION_OPERATIVA');
  return especificos.length ? especificos : bloqueos;
};

const versionProcesoDe = proceso => obtenerPrimero(proceso,
  ['VersionRegistroProceso', 'versionRegistroProceso', 'VersionRegistro', 'versionRegistro'], null);

// One explicit user action, using only the versions returned by the authoritative reload.
// Never reuse the React closure's plan after generating a new one.
export const ejecutarCierre = async ({ proceso, exigirAplicacion = false, generar, recargar, aplicar, completar, onAplicando }) => {
  const version = versionProcesoDe(proceso);
  if (version == null) throw new Error('No se encontró la versión vigente del proceso. Recarga el asistente.');
  await generar({ VersionRegistroProceso: version });
  const carga = await recargar();
  if (obtenerPreguntasPendientes(carga.definicion, carga.respuestas, carga.seccionesOmitidas).length) {
    throw new Error('Quedan preguntas pendientes. Respóndelas u omítelas antes de finalizar.');
  }
  if (!esPlanVigente(carga.plan, carga.proceso)) {
    throw new Error('Las respuestas cambiaron durante la comprobación. Intenta finalizar nuevamente.');
  }
  const versionProceso = versionProcesoDe(carga.proceso);
  if (exigirAplicacion && !carga.contextoIntegracionDisponible) throw new Error('No pudimos comprobar la aplicación de cambios. Intenta finalizar nuevamente.');
  if (carga.contextoIntegracionDisponible) {
    if (!carga.aplicacionOperativaHabilitada) throw new Error('La aplicación de cambios aún no está habilitada para esta empresa. Tus respuestas están guardadas.');
    if (!carga.puedeAplicarConfiguracion || bloqueosDelPlan(carga.plan).length) {
      throw new Error('Hay configuraciones que necesitan atención. Revisa las indicaciones de abajo.');
    }
    const versionPlan = obtenerPrimero(carga.plan, ['VersionRegistroPlan', 'versionRegistroPlan', 'VersionRegistro', 'versionRegistro'], null);
    if (versionPlan == null) throw new Error('No se encontró la versión del plan. Intenta finalizar nuevamente.');
    onAplicando();
    return aplicar({ VersionRegistroProceso: versionProceso, VersionRegistroPlan: versionPlan, ConfirmacionExplicita: true });
  }
  // Preserve the explicitly non-operational legacy mode; never use it as fallback for a disabled flag.
  onAplicando();
  return completar({ VersionRegistroProceso: versionProceso, ConvertirParaDespuesEnOmitidas: false });
};
